<template>
  <div>
    <v-card>
      <v-card-title>
        <v-toolbar flat>
          <v-toolbar-title>個人資料</v-toolbar-title>

        </v-toolbar>
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="isFormValid"
          :lazy-validation="true"
        >
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-avatar
                  color="black"
                  @click="onAvatarClicked"
                >
                  <img
                    v-if="form.newAvatar.url||form.newAvatar.blobURL"
                    :src="form.newAvatar.url||form.newAvatar.blobURL"
                    alt="new avatar"
                  >
                  <img
                    v-else-if="me.Profile && me.Profile.AvatarUrl"
                    :src="me.Profile.AvatarUrl"
                    alt="avatar"
                  >
                  <span
                    v-else
                    class="white--text headline"
                  >{{me.Profile && me.Profile.Name && me.Profile.Name.substr(0,1)}}</span>
                </v-avatar>
                <input
                  ref="avatarFileInput"
                  hidden
                  type="file"
                  accept="image/*"
                  @change="onAvatarFileChanged"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="form.Name"
                  label="姓名"
                  :rules="formRules.name"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <a
                  href="javascript:;"
                  @click="isShowEditPasswordDialog=true"
                >修改密碼</a>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          :disabled="!isFormValid || !isDataChanged"
          @click="save"
        >儲存</v-btn>
      </v-card-actions>
    </v-card>

    <password-edit-dialog
      v-model="isShowEditPasswordDialog"
      @updated="alertMessage('成功修改密碼!')"
    />

    <v-dialog
      scrollable
      v-model="isLoading"
      fullscreen
    >
      <v-container
        fluid
        fill-height
        style="background-color: rgba(0, 0, 0, 0.5);"
      >
        <v-layout
          justify-center
          align-center
        >
          <v-progress-circular
            indeterminate
            color="white"
          ></v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PasswordEditDialog from "@/ui/me/password-edit-dialog.vue";
import ImageThumbnailer from "@/utils/ImageThumbnailer.js";
export default {
  components: {
    PasswordEditDialog
  },
  data: () => ({
    isLoading: false,
    isShowEditPasswordDialog: false,
    isFormValid: false,
    form: { Name: "", newAvatar: {}, AvatarUrl: "", Level: 1 }
  }),
  computed: {
    formRules() {
      return {
        name: [v => !!v || "請輸入名稱"]
      };
    },
    isDataChanged() {
      return (
        this.form.Name !=
          (this.me && this.me.Profile && this.me.Profile.Name) ||
        this.form.AvatarUrl !=
          (this.me && this.me.Profile && this.me.Profile.AvatarUrl) ||
        this.form.newAvatar.blobURL
      );
    },
    ...mapGetters(["me"])
  },
  methods: {
    onAvatarClicked() {
      this.$refs.avatarFileInput.click();
    },
    onAvatarFileChanged() {
      let opt = {
        maxWidth: 300,
        maxHeight: 300
      };
      var newAvatarFile = this.$refs.avatarFileInput.files[0];
      this.form.newAvatar.file = newAvatarFile;
      ImageThumbnailer.shared.requestCompress(
        newAvatarFile,
        blob => {
          this.$set(this.form.newAvatar, "compressedBlob", blob);
          this.$set(this.form.newAvatar, "blobURL", URL.createObjectURL(blob));
        },
        opt
      );
    },
    updateProfile() {
      return this.$services.user.updateMe(this, { Profile: this.form });
    },
    uploadNewAvatarIfExists() {
      if (!this.form.newAvatar.file)
        return new Promise((resolve, reject) => resolve());

      var fileName = this.form.newAvatar.file.name;
      var arr = fileName.split(".");
      var fileExtension = arr[arr.length - 1];

      return this.$services.firebase
        .upload(
          this.form.newAvatar.compressedBlob,
          "user/" + this.me.ID + "/",
          "jpg"
        )
        .then(url => {
          if (url) {
            this.form.AvatarUrl = url;
            if (this.form.newAvatar.url) {
              URL.revokeObjectURL(this.form.newAvatar.url);
            }
            this.form.newAvatar = {};
          }
        });
    },
    save() {
      if (!this.$refs.form.validate()) return;

      this.isLoading = true;
      this.uploadNewAvatarIfExists()
        .then(this.updateProfile)
        .then(res => {
          this.$set(this.me, "Profile", this.form);
          this.resetForm();
          // this.$alertMessage("成功修改資料!");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    resetForm() {
      this.form = Object.assign(
        JSON.parse(JSON.stringify(this.me.Profile || {})),
        { newAvatar: {} }
      );
      if (this.$refs.form) this.$refs.form.resetValidation();
    }
  },
  created() {
    this.$services.prepareDatas(this).then(this.resetForm);
  },
  watch: {
    me() {
      this.resetForm();
    }
  }
};
</script>